import { render, staticRenderFns } from "./List-Shipments.vue?vue&type=template&id=49a002b0"
import script from "./List-Shipments.vue?vue&type=script&lang=js"
export * from "./List-Shipments.vue?vue&type=script&lang=js"
import style0 from "./List-Shipments.vue?vue&type=style&index=0&id=49a002b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports